import permission from './permission'

const install = function (Vue) {
  Vue.directive('withdraw', permission)
  Vue.directive('financials-setting', permission)
  Vue.directive('qr-stand', permission)
}

if (window.Vue) {
  window['withdraw'] = permission
  window['financials-setting'] = permission
  window['qr-stand'] = permission
  Vue.use(install) // eslint-disable-line
}

permission.install = install
export default permission
